import React from "react";
import { formatBoldText } from "../util/helperFunctions";

function MessageComponent({ message, is_deleted }) {
  return <>{is_deleted ? <span className='deleted-chat'>DELETED CHAT</span> : formatBoldText(message)}</>;
}

export default MessageComponent;
